"use client";

import { useQuery } from "convex/react";
import { api } from "../../../../../convex/_generated/api";
import {
  ProfileSection,
  NotificationSection,
  BillingSection,
  DangerZoneSection,
} from "@/components/settings/SettingsSections";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { SettingsIcon } from "@/components/icons";
import { VoiceGuideButton } from "@/components/voice/VoiceGuideButton";
import { usePageTitle } from "@/lib/usePageTitle";

export default function SettingsPage() {
  usePageTitle("Settings");
  const user = useQuery(api.users.getCurrentUser);

  return (
    <div>
      <div className="mb-6">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div>
            <h1 className="flex items-center gap-2 text-2xl font-bold text-foreground">
              <SettingsIcon className="h-6 w-6" />
              Settings
            </h1>
            <p className="mt-1 text-muted">Manage your account and preferences</p>
          </div>
          <VoiceGuideButton
            track="features"
            label="Listen: features overview"
            aria-label="Play voice guide about BlockyNetworks features"
          />
        </div>
      </div>

      <div className="mx-auto max-w-2xl space-y-6">
        {user === undefined ? (
          <>
            <Skeleton className="h-64" />
            <Skeleton className="h-48" />
          </>
        ) : user === null ? (
          <Card>
            <CardContent className="py-12 text-center">
              <p className="text-muted">Please sign in to access settings</p>
            </CardContent>
          </Card>
        ) : (
          <>
            <ProfileSection user={user} />
            <NotificationSection user={user} />
            <BillingSection user={user} />
            <DangerZoneSection />
          </>
        )}
      </div>
    </div>
  );
}
